(() => {
      const removeLegacyDashboardLink = () => {
        document.querySelectorAll('a[href="https://guyii.com/pages/sales-dashboard"]').forEach((link) => {
          const bar = link.closest(".announcement-bar--center");
          if (!bar) return;
          if (link.previousSibling && link.previousSibling.nodeType === Node.TEXT_NODE) link.previousSibling.remove();
          link.remove();
        });
      };
      removeLegacyDashboardLink();
      const observer = new MutationObserver(removeLegacyDashboardLink);
      observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
      window.setTimeout(() => observer.disconnect(), 8000);
    })();

(() => {
      if (window.__guyiiBusinessCenterInitialized) return;
      window.__guyiiBusinessCenterInitialized = true;

      const LOGIN_USERNAME = "guyii";
      const LOGIN_PASSWORD = "Guyii@112233";
      const AUTH_KEY = "guyiiBusinessCenterAuth";
      const businessData = window.GUYII_BUSINESS_DATA;
      const orders = businessData?.orders;
      const sales = businessData?.sales;
      const moneyFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const loadingLayer = document.getElementById("loadingLayer");
      const loadingTitle = document.getElementById("loadingTitle");
      const loadingDesc = document.getElementById("loadingDesc");
      const loginPage = document.getElementById("loginPage");
      const portal = document.getElementById("portal");
      const toast = document.getElementById("toast");
      if (!Array.isArray(orders) || !Array.isArray(sales)) {
        loadingLayer.classList.remove("active");
        portal.classList.add("hidden");
        loginPage.classList.remove("hidden");
        document.getElementById("loginError").textContent = "Unable to load data. Reload this page to try again.";
        document.querySelectorAll("#loginForm input, #loginForm button").forEach((input) => { input.disabled = true; });
        return;
      }
      const state = { tab: "orders", orderPage: 1, orderPageSize: 10, orderKeyword: "", orderStatus: "all", start: "2026-01", end: "2026-03" };

      function formatMoney(value) { return "$" + moneyFormatter.format(Number(value || 0)); }
      function escapeHtml(value) {
        return String(value ?? "").replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[character]);
      }
      function showLoading(title, description, duration, callback) {
        loadingTitle.textContent = title;
        loadingDesc.textContent = description;
        loadingLayer.classList.add("active");
        window.setTimeout(() => {
          loadingLayer.classList.remove("active");
          if (callback) callback();
        }, duration);
      }
      function showToast(message) {
        toast.textContent = message;
        toast.classList.add("active");
        window.clearTimeout(showToast.timer);
        showToast.timer = window.setTimeout(() => toast.classList.remove("active"), 2600);
      }
      function productArt(type) {
        const paths = {
          table: '<path d="M8 27h26M11 27v8M31 27v8M13 18h18v9H13z" fill="none" stroke="#58725d" stroke-width="1.7"/><path d="M16 18v-5h12v5" fill="none" stroke="#9bb39a" stroke-width="1.7"/>',
          sofa: '<path d="M7 27v-8c0-4 3-6 6-6h16c3 0 6 2 6 6v8M10 27v-6h22v6M11 27v7M31 27v7" fill="none" stroke="#58725d" stroke-width="1.7"/>',
          coffee: '<path d="M8 19h26l-3 7H11zM13 26v8M29 26v8" fill="none" stroke="#58725d" stroke-width="1.7"/><path d="M16 19v-5h10v5" fill="none" stroke="#9bb39a" stroke-width="1.7"/>',
          cabinet: '<path d="M10 9h22v25H10zM14 13h14v6H14zM14 23h14v7H14z" fill="none" stroke="#58725d" stroke-width="1.7"/><circle cx="25" cy="16" r=".9" fill="#9bb39a"/><circle cx="25" cy="26" r=".9" fill="#9bb39a"/>',
          chair: '<path d="M13 10v15c0 3 2 5 5 5h8c4 0 6-2 6-5V17c0-4-3-7-7-7H13zM13 25H8M27 30v5M13 30v5" fill="none" stroke="#58725d" stroke-width="1.7"/>'
        };
        return '<svg viewBox="0 0 42 42" aria-hidden="true"><rect width="42" height="42" fill="#edf3ed"/>' + (paths[type] || paths.table) + "</svg>";
      }
      function getFilteredOrders() {
        const keyword = state.orderKeyword.trim().toLowerCase();
        return orders.filter((order) => {
          const searchable = [order.orderNo, order.product, order.address].join(" ").toLowerCase();
          const matchesKeyword = !keyword || searchable.includes(keyword);
          const matchesStatus = state.orderStatus === "all" || order.status === state.orderStatus;
          return matchesKeyword && matchesStatus;
        });
      }
      function getPaginationItems(totalPages, currentPage) {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
        const pages = new Set([1, totalPages, currentPage - 1, currentPage, currentPage + 1]);
        if (currentPage <= 3) [2, 3, 4].forEach((page) => pages.add(page));
        if (currentPage >= totalPages - 2) [totalPages - 3, totalPages - 2, totalPages - 1].forEach((page) => pages.add(page));
        const sorted = [...pages].filter((page) => page >= 1 && page <= totalPages).sort((left, right) => left - right);
        const result = [];
        sorted.forEach((page, index) => {
          if (index > 0 && page - sorted[index - 1] > 1) result.push("...");
          result.push(page);
        });
        return result;
      }
      function renderOrders() {
        const data = getFilteredOrders();
        const totalPages = Math.max(1, Math.ceil(data.length / state.orderPageSize));
        state.orderPage = Math.min(state.orderPage, totalPages);
        const start = (state.orderPage - 1) * state.orderPageSize;
        const pageData = data.slice(start, start + state.orderPageSize);
        document.getElementById("orderCount").textContent = `${data.length.toLocaleString("en-US")} orders`;
        const body = document.getElementById("orderTableBody");
        body.innerHTML = pageData.length ? pageData.map((order) => {
          const statusClass = order.status === "Unshipped" ? "pending" : "";
          return `<tr><td><div class="product-cell"><span class="product-thumb">${productArt(order.image)}</span><div><div class="product-name">${escapeHtml(order.product)}</div><div class="product-spec">Product code</div></div></div></td><td><span class="order-number">#${escapeHtml(order.orderNo)}</span></td><td class="address-cell">${escapeHtml(order.address)}</td><td class="money-cell">${formatMoney(order.amount)}</td><td><span class="status-pill ${statusClass}">${escapeHtml(order.status)}</span></td><td>${escapeHtml(String(order.purchaseDate || "").slice(0, 10))}</td></tr>`;
        }).join("") : '<tr><td class="empty-row" colspan="6">No orders found</td></tr>';
        const pagination = document.getElementById("orderPagination");
        let paginationHtml = `<span class="page-note">Page ${data.length ? state.orderPage : 0} of ${data.length ? totalPages : 0}</span><button class="page-button" type="button" data-page="prev" ${state.orderPage <= 1 ? "disabled" : ""}>Previous</button>`;
        getPaginationItems(totalPages, state.orderPage).forEach((page) => {
          if (page === "...") paginationHtml += '<button class="page-button ellipsis" type="button" disabled>...</button>';
          else paginationHtml += `<button class="page-button ${page === state.orderPage ? "active" : ""}" type="button" data-page="${page}">${page}</button>`;
        });
        paginationHtml += `<button class="page-button" type="button" data-page="next" ${state.orderPage >= totalPages ? "disabled" : ""}>Next</button>`;
        pagination.innerHTML = paginationHtml;
      }
      function renderSales() {
        const data = sales.filter((item) => item.month >= state.start && item.month <= state.end);
        document.getElementById("salesSubtitle").textContent = data.length ? `${state.start} - ${state.end} - ${data.length} months` : "No data for this range";
        document.getElementById("salesTableBody").innerHTML = data.length ? data.map((item) => `<tr><td>${escapeHtml(item.label)}</td><td><span class="status-pill">Loaded</span></td><td>${formatMoney(item.sales)}</td></tr>`).join("") : '<tr><td colspan="3" class="empty-row">No sales data found</td></tr>';
        renderSalesChart(data);
      }
      function renderSalesChart(data) {
        const svg = document.getElementById("salesChart");
        const width = 860;
        const height = 330;
        const padding = { top: 24, right: 30, bottom: 54, left: 70 };
        const innerWidth = width - padding.left - padding.right;
        const innerHeight = height - padding.top - padding.bottom;
        if (!data.length) {
          svg.innerHTML = '<text x="430" y="165" text-anchor="middle" fill="#9aa099" font-size="13">No data</text>';
          return;
        }
        const max = Math.max(...data.map((item) => item.sales), 1);
        const chartMax = max * 1.18;
        const x = (index) => data.length === 1 ? padding.left + innerWidth / 2 : padding.left + innerWidth * index / (data.length - 1);
        const y = (value) => padding.top + innerHeight - innerHeight * value / chartMax;
        const points = data.map((item, index) => [x(index), y(item.sales)]);
        const line = points.map((point, index) => `${index ? "L" : "M"}${point[0].toFixed(2)} ${point[1].toFixed(2)}`).join(" ");
        const area = `${line} L ${points[points.length - 1][0].toFixed(2)} ${padding.top + innerHeight} L ${points[0][0].toFixed(2)} ${padding.top + innerHeight} Z`;
        const grid = [0, .25, .5, .75, 1].map((ratio) => {
          const yPosition = padding.top + innerHeight * (1 - ratio);
          return `<line x1="${padding.left}" x2="${width - padding.right}" y1="${yPosition}" y2="${yPosition}" stroke="#eeeae3"/><text x="${padding.left - 13}" y="${yPosition + 4}" text-anchor="end" fill="#9aa099" font-size="11">$${Math.round(chartMax * ratio / 1000)}k</text>`;
        }).join("");
        const labels = data.map((item, index) => `<text x="${points[index][0]}" y="${height - 17}" text-anchor="middle" fill="#737a74" font-size="11">${escapeHtml(item.label)}</text>`).join("");
        const dots = data.map((item, index) => `<circle cx="${points[index][0]}" cy="${points[index][1]}" r="5" fill="#fff" stroke="#58725d" stroke-width="3"><title>${escapeHtml(item.label)}: ${formatMoney(item.sales)}</title></circle>`).join("");
        svg.innerHTML = `<defs><linearGradient id="salesArea" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#9bb39a" stop-opacity=".34"/><stop offset="1" stop-color="#9bb39a" stop-opacity=".02"/></linearGradient></defs>${grid}<path d="${area}" fill="url(#salesArea)"/><path d="${line}" fill="none" stroke="#58725d" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>${dots}${labels}`;
      }
      function enterPortal() {
        loginPage.classList.add("hidden");
        portal.classList.remove("hidden");
        state.tab = "orders";
        document.querySelectorAll(".side-link").forEach((link) => link.classList.toggle("active", link.dataset.tab === "orders"));
        document.getElementById("ordersView").classList.remove("hidden");
        document.getElementById("salesView").classList.add("hidden");
        document.getElementById("breadcrumbText").textContent = "Orders";
        const table = document.getElementById("orderTableWrap");
        table.classList.add("table-loading");
        window.setTimeout(() => { table.classList.remove("table-loading"); renderOrders(); }, 680);
      }
      function showLogin() {
        portal.classList.add("hidden");
        loginPage.classList.remove("hidden");
        document.getElementById("username").focus();
      }

      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const availableMonths = [...new Set(sales.map((item) => item.month))]
        .filter((month) => /^\d{4}-(0[1-9]|1[0-2])$/.test(month)).sort();
      const monthMin = availableMonths[0] || "";
      const monthMax = availableMonths[availableMonths.length - 1] || "";
      const monthPickerState = { input: null, year: Number(monthMax.slice(0, 4)) || new Date().getFullYear() };
      document.querySelectorAll(".month-input").forEach((input) => {
        input.min = monthMin;
        input.max = monthMax;
        input.disabled = availableMonths.length === 0;
        if (availableMonths.length && (!input.value || input.value < monthMin || input.value > monthMax)) {
          input.value = input.id === "rangeStart" ? monthMin : monthMax;
        }
      });
      state.start = document.getElementById("rangeStart").value;
      state.end = document.getElementById("rangeEnd").value;
      const monthNumber = (value) => {
        const [year, month] = String(value || "").split("-").map(Number);
        return year * 12 + month;
      };
      const closeMonthPickers = () => {
        document.querySelectorAll("[data-month-picker]").forEach((picker) => picker.classList.add("hidden"));
        document.querySelectorAll(".month-input").forEach((input) => input.setAttribute("aria-expanded", "false"));
        monthPickerState.input = null;
      };
      const renderMonthPicker = (input, year) => {
        const picker = input.closest(".month-field").querySelector("[data-month-picker]");
        const current = input.value;
        picker.querySelector("[data-month-picker-year]").textContent = String(year);
        picker.querySelector(".month-picker-grid").innerHTML = monthNames.map((name, index) => {
          const value = `${year}-${String(index + 1).padStart(2, "0")}`;
          const disabled = monthNumber(value) < monthNumber(monthMin) || monthNumber(value) > monthNumber(monthMax);
          const selected = value === current ? " selected" : "";
          return `<button class="month-picker-option${selected}" type="button" data-month-value="${value}"${disabled ? " disabled" : ""}>${name}</button>`;
        }).join("");
        picker.querySelector('[data-month-step="-1"]').disabled = year <= Number(monthMin.slice(0, 4));
        picker.querySelector('[data-month-step="1"]').disabled = year >= Number(monthMax.slice(0, 4));
      };
      const openMonthPicker = (input) => {
        closeMonthPickers();
        monthPickerState.input = input;
        monthPickerState.year = Number(input.value.slice(0, 4)) || Number(monthMax.slice(0, 4));
        input.setAttribute("aria-expanded", "true");
        input.closest(".month-field").querySelector("[data-month-picker]").classList.remove("hidden");
        renderMonthPicker(input, monthPickerState.year);
      };
      document.querySelectorAll(".month-input").forEach((input) => input.addEventListener("click", (event) => {
        event.preventDefault();
        openMonthPicker(input);
      }));
      document.querySelectorAll(".month-input").forEach((input) => input.addEventListener("keydown", (event) => {
        if (["Enter", " ", "ArrowDown"].includes(event.key)) {
          event.preventDefault();
          openMonthPicker(input);
        } else if (event.key === "Escape") {
          closeMonthPickers();
        }
      }));
      document.querySelectorAll("[data-month-picker]").forEach((picker) => picker.addEventListener("click", (event) => {
        const stepButton = event.target.closest("[data-month-step]");
        if (stepButton) {
          monthPickerState.year += Number(stepButton.dataset.monthStep);
          renderMonthPicker(monthPickerState.input, monthPickerState.year);
          return;
        }
        const monthButton = event.target.closest("[data-month-value]");
        if (!monthButton || monthButton.disabled) return;
        const input = picker.closest(".month-field").querySelector(".month-input");
        input.value = monthButton.dataset.monthValue;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        closeMonthPickers();
      }));
      document.addEventListener("click", (event) => {
        if (!event.target.closest(".month-field")) closeMonthPickers();
      });

      document.getElementById("loginForm").addEventListener("submit", (event) => {
        event.preventDefault();
        const username = document.getElementById("username").value.trim();
        const password = document.getElementById("password").value;
        const error = document.getElementById("loginError");
        const submit = document.getElementById("loginSubmit");
        error.textContent = "";
        if (username !== LOGIN_USERNAME || password !== LOGIN_PASSWORD) {
          error.textContent = "Incorrect username or password.";
          document.getElementById("password").select();
          return;
        }
        submit.disabled = true;
        submit.textContent = "Signing in...";
        showLoading("Signing in", "Checking account access", 900, () => {
          sessionStorage.setItem(AUTH_KEY, "1");
          submit.disabled = false;
          submit.textContent = "Sign in";
          enterPortal();
        });
      });
      document.querySelectorAll(".side-link").forEach((link) => link.addEventListener("click", () => {
        const tab = link.dataset.tab;
        if (tab === state.tab) return;
        showLoading(tab === "orders" ? "Loading orders" : "Loading sales", "Requesting the latest view", 620, () => {
          state.tab = tab;
          document.querySelectorAll(".side-link").forEach((item) => item.classList.toggle("active", item === link));
          document.getElementById("ordersView").classList.toggle("hidden", tab !== "orders");
          document.getElementById("salesView").classList.toggle("hidden", tab !== "sales");
          document.getElementById("breadcrumbText").textContent = tab === "orders" ? "Orders" : "Sales";
          if (tab === "orders") renderOrders(); else renderSales();
        });
      }));
      document.getElementById("orderFilterForm").addEventListener("submit", (event) => {
        event.preventDefault();
        state.orderKeyword = document.getElementById("orderKeyword").value;
        state.orderStatus = document.getElementById("orderStatus").value;
        state.orderPage = 1;
        const button = document.getElementById("orderQueryButton");
        button.disabled = true;
        button.textContent = "Searching...";
        showLoading("Searching orders", "Filtering order records", 760, () => {
          button.disabled = false;
          button.textContent = "Search";
          renderOrders();
          showToast("Order search complete");
        });
      });
      document.getElementById("orderPagination").addEventListener("click", (event) => {
        const button = event.target.closest("[data-page]");
        if (!button || button.disabled) return;
        const totalPages = Math.max(1, Math.ceil(getFilteredOrders().length / state.orderPageSize));
        if (button.dataset.page === "prev") state.orderPage -= 1;
        else if (button.dataset.page === "next") state.orderPage += 1;
        else state.orderPage = Number(button.dataset.page);
        state.orderPage = Math.max(1, Math.min(state.orderPage, totalPages));
        renderOrders();
      });
      document.getElementById("salesFilterForm").addEventListener("submit", (event) => {
        event.preventDefault();
        const start = document.getElementById("rangeStart").value;
        const end = document.getElementById("rangeEnd").value;
        if (!start || !end) { showToast("Select a complete month range"); return; }
        if (start > end) { showToast("The start month must be before the end month"); return; }
        state.start = start;
        state.end = end;
        const button = document.getElementById("salesQueryButton");
        button.disabled = true;
        button.textContent = "Searching...";
        showLoading("Searching sales", "Preparing the selected months", 820, () => {
          button.disabled = false;
          button.textContent = "Search";
          renderSales();
          showToast("Sales view updated");
        });
      });
      document.getElementById("logoutButton").addEventListener("click", () => {
        sessionStorage.removeItem(AUTH_KEY);
        showLoading("Signing out", "Closing the current session", 520, showLogin);
      });
      window.setTimeout(() => {
        if (sessionStorage.getItem(AUTH_KEY) === "1") showLoading("Restoring session", "Loading your workspace", 650, enterPortal);
        else { loadingLayer.classList.remove("active"); showLogin(); }
      }, 1050);
    })();
